
import { defineComponent, computed, ref, PropType } from 'vue';
import useConverter from '@/composables/general/useConverter';
import useStringManip from '@/composables/general/useStringManip';
import { IAskusQuestion } from '@/models/askus.model';

export default defineComponent({
  //Prevents warning caused by the keep alive functionality.
  // Warnings included -> use of externious Props...etc
  inheritAttrs: false,
  name: 'AskusList',
  props: {
    questions: {
      type: Array as PropType<IAskusQuestion[]>,
      required: true,
    },
  },
  components: {},
  emits: ['openQuestion'],
  setup(props, context) {
    const { truncateAfterWord } = useStringManip();
    const { formattedDate } = useConverter();

    function openQuestion(question: IAskusQuestion, questionid: number) {
      context.emit('openQuestion', question, questionid);
    }

    return {
      formattedDate,
      truncateAfterWord,
      openQuestion,
    };
  },
});
